import { render } from "./annullationdefacture.vue?vue&type=template&id=d6e683a4&scoped=true"
import script from "./annullationdefacture.vue?vue&type=script&lang=js"
export * from "./annullationdefacture.vue?vue&type=script&lang=js"

import "./annullationdefacture.vue?vue&type=style&index=0&id=d6e683a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e683a4"]])

export default __exports__